export function getQualityScore(stats: any) {
  const packetLossPercent = stats.packetsLost / stats.totalPackets || 0;
  const { jitter } = stats;
  const { rtt } = stats;
  let score = 100;
  score -= packetLossPercent * 50 > 50 ? 50 : packetLossPercent * 50;
  score -= ((jitter / 30) * 25 > 25 ? 25 : (jitter / 30) * 25) || 0;
  score -= ((rtt / 300) * 25 > 25 ? 25 : (rtt / 300) * 25) || 0;
  return score / 10;
}

export const nameTructed = (name: any, tructedLength: any) => {
  if (name?.length > tructedLength) {
    if (tructedLength === 15) {
      return `${name.substr(0, 12)}...`;
    }
    return `${name.substr(0, tructedLength)}...`;
  }
  return name;
};

export const sideBarModes = {
  PARTICIPANTS: "PARTICIPANTS",
  CHAT: "CHAT",
};
